import { configureStore } from "@reduxjs/toolkit";
import reducer1 from "../redux/classify/hscodeSlice";
import reducer2 from "../redux/classify/productkeywordSlice";
import reducer3 from "../redux/landed-cost/singlehsCodeSlice";
import reducer4 from "../redux/imports-compliance/imports-compliance-slice";
import reducer5 from "../redux/classify/scheduleBSlice";
import reducer6 from "../redux/profile/profileSlice";
import reducer7 from "./export-compliance-slice/export-compliance-slice";
import reducer8 from "./eccn-classification/eccn-classification-slice";
import reducer9 from "../redux/profile/plansSlice";
import sidebar from "../../components/side-bar/sidebarSlice";
import complianceRequest from "./compliance-request/compliance-request-slice";
import userAccess from "./userAccess/userAccessSlice";
import notifications from "./notifications/notificationSlice";

export const store = configureStore({
  reducer: {
    hscodeData: reducer1,
    productkeywordData: reducer2,
    singlehscodeData: reducer3,
    importscompliancedata: reducer4,
    scheduleBdata: reducer5,
    profiledata: reducer6,
    exportCompliance: reducer7,
    eccnClassification: reducer8,
    plansData: reducer9,
    sidebar,
    complianceRequest: complianceRequest,
    userAccess: userAccess,
    notifications: notifications,
  },
});
